module.exports = __webpack_public_path__ + "img/angle.00dc585f.png";